import { useState } from 'react'

import { useMemoizedFn } from 'ahooks'
import {
  $getSelection,
  $isRangeSelection,
  ElementFormatType,
  FORMAT_ELEMENT_COMMAND
} from 'lexical'

import { $getSelectedElement } from '../../utils/element'
import { useEditor } from '../useEditor'
import { useSelectionChange } from '../useSelectionChange'

export const useSelectionElementFormat = () => {
  const editor = useEditor()
  const [elementFormat, _setElementFormat] = useState<ElementFormatType>('left')

  const getElementFormatHandler = () => {
    let elementFormat: ElementFormatType | undefined
    const selection = $getSelection()
    if ($isRangeSelection(selection)) {
      const node = $getSelectedElement(selection.anchor.getNode())
      elementFormat = node.getFormatType()
    }
    _setElementFormat(elementFormat || 'left')
    return false
  }

  useSelectionChange(getElementFormatHandler)

  const setElementFormat = useMemoizedFn((elementFormat: ElementFormatType) => {
    _setElementFormat(elementFormat)
    editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, elementFormat)
  })

  return [elementFormat, setElementFormat] as const
}
